export default __webpack_public_path__ + "static/bmw-b256c1b24dd66a5742974026820e69e3.png";